import React, { memo } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import {
  ShipmentAutosuggest,
  IShipmentAutosuggestProps,
} from '../ShipmentAutosuggest/ShipmentAutosuggest'

type IBaseControllerProps = ControllerProps<React.ComponentType<IShipmentAutosuggestProps>>

export interface IControlledShipmentAutosuggestProps
  extends Pick<
    IBaseControllerProps,
    | 'control'
    | 'name'
    | 'defaultValue'
    | 'AutocompleteProps'
    | 'enableCreateShipment'
    | 'onShipmentChange'
    | 'onCreateShipment'
    | 'onClear'
    | 'inputValue'
    | 'onInputValueChange'
    | 'shipment'
    | 'optionLabelGenerator'
    | 'filters'
    | 'minimumSearchLength'
  > {}

const ControlledShipmentAutosuggest = memo<IControlledShipmentAutosuggestProps>(
  ({
    AutocompleteProps,
    control,
    defaultValue,
    enableCreateShipment,
    filters,
    inputValue,
    minimumSearchLength,
    name = 'shipmentApplicationId',
    onClear,
    onCreateShipment,
    onInputValueChange,
    onShipmentChange,
    optionLabelGenerator,
    shipment,
  }) => {
    return (
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ name, onBlur, onChange, ref, value }) => {
          return (
            <ShipmentAutosuggest
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              name={name}
              ref={ref}
              filters={filters}
              shipment={shipment}
              optionLabelGenerator={optionLabelGenerator}
              inputValue={inputValue}
              onInputValueChange={onInputValueChange}
              enableCreateShipment={enableCreateShipment}
              onShipmentChange={onShipmentChange}
              onCreateShipment={onCreateShipment}
              onClear={onClear}
              minimumSearchLength={minimumSearchLength}
              AutocompleteProps={AutocompleteProps}
            />
          )
        }}
      />
    )
  }
)

export default ControlledShipmentAutosuggest
